import userInfo from "./userInfo/index";
import database from "./database/index";
import dataSearch from "./dataSearch/index";

export default {
  userInfo,
  database,
  dataSearch,
};
